import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "./utils";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

export const clinicPatientLinkApi = createApi({
  reducerPath: "clinicPatientLinkApi",
  baseQuery: baseQueryWithReauth,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  tagTypes: ["ClinicPatientLink"],
  endpoints: (builder) => ({
    lookupClinicPatientLink: builder.mutation({
      query: (data) =>
        apiFunction(data, "/api/clinic/clinic-patient-link/lookup", "POST"),
    }),
    requestClinicPatientLink: builder.mutation({
      query: (data) =>
        apiFunction(data, "/api/clinic/clinic-patient-link/request", "POST"),
      invalidatesTags: ["ClinicPatientLink"],
    }),
    directAddClinicPatientLink: builder.mutation({
      query: (data) =>
        apiFunction(data, "/api/clinic/clinic-patient-link/direct-add", "POST"),
      invalidatesTags: ["ClinicPatientLink"],
    }),
    manualCreateClinicPatientLink: builder.mutation({
      query: (data) =>
        apiFunction(
          data,
          "/api/clinic/clinic-patient-link/manual-create",
          "POST"
        ),
      invalidatesTags: ["ClinicPatientLink"],
    }),
    cancelClinicPatientLink: builder.mutation({
      query: ({ token, linkId }) =>
        apiFunction(
          { token },
          `/api/clinic/clinic-patient-link/${linkId}/cancel`,
          "POST"
        ),
      invalidatesTags: ["ClinicPatientLink"],
    }),
    terminateClinicPatientLink: builder.mutation({
      query: ({ token, linkId }) =>
        apiFunction(
          { token },
          `/api/clinic/clinic-patient-link/${linkId}/terminate`,
          "POST"
        ),
      invalidatesTags: ["ClinicPatientLink"],
    }),
    listClinicPatientLinks: builder.query({
      query: ({ token, group }) => ({
        url: `/api/clinic/clinic-patient-link?group=${encodeURIComponent(group)}`,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      }),
      providesTags: ["ClinicPatientLink"],
    }),
  }),
});

export const {
  useLookupClinicPatientLinkMutation,
  useRequestClinicPatientLinkMutation,
  useDirectAddClinicPatientLinkMutation,
  useManualCreateClinicPatientLinkMutation,
  useCancelClinicPatientLinkMutation,
  useTerminateClinicPatientLinkMutation,
  useListClinicPatientLinksQuery,
} = clinicPatientLinkApi;
